import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { formatDateTime } from "@/lib/format";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export default function Audit() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs").then(({ data }) => setRows(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-slate-900">{t("menu.audit")}</h1>
        <p className="text-sm text-slate-500 mt-1">Registro completo delle attività</p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto">
        <Table>
          <TableHeader><TableRow className="bg-slate-50">
            <TableHead className="text-xs uppercase text-slate-500">Data</TableHead>
            <TableHead className="text-xs uppercase text-slate-500">Utente</TableHead>
            <TableHead className="text-xs uppercase text-slate-500">Ruolo</TableHead>
            <TableHead className="text-xs uppercase text-slate-500">Azione</TableHead>
            <TableHead className="text-xs uppercase text-slate-500">Entità</TableHead>
            <TableHead className="text-xs uppercase text-slate-500">IP</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {loading ? <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400">{t("common.loading")}</TableCell></TableRow>
              : rows.length === 0 ? <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400">{t("common.none")}</TableCell></TableRow>
              : rows.map((r) => (
                <TableRow key={r.id} data-testid="audit-row">
                  <TableCell className="text-sm text-slate-500">{formatDateTime(r.created_at)}</TableCell>
                  <TableCell className="text-sm">{r.user_email || "—"}</TableCell>
                  <TableCell className="text-sm text-slate-600 capitalize">{r.user_role || "—"}</TableCell>
                  <TableCell><span className="text-xs font-medium px-2 py-0.5 rounded bg-slate-100 capitalize">{r.action}</span></TableCell>
                  <TableCell className="text-sm text-slate-600 capitalize">{r.entity}</TableCell>
                  <TableCell className="text-sm text-slate-400 font-mono">{r.ip || "—"}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
